import { FC, Fragment } from 'react';
import { BRING_WHAT_LIST, ItemProps } from '@portalCommon/constants';
import classnames from 'classnames/bind';
import { OptimizedImg } from '@commonPackage/components';
import styles from './index.module.less';

const cx = classnames.bind(styles);

const BringWhatItem: FC<ItemProps> = ({ imgSrc, title, text }) => {
  return (
    <div className={cx('bw-item')} key={imgSrc}>
      <OptimizedImg loading="lazy" src={imgSrc} alt={title} />
      <p>{title}</p>
      <p>{text}</p>
    </div>
  );
};

export function BringWhat() {
  return (
    <section className={cx('bring-what')}>
      {BRING_WHAT_LIST.map((item, index) => (
        <Fragment key={index}>
          <BringWhatItem {...item} />
        </Fragment>
      ))}
    </section>
  );
}
